<template>
<div>
    <v-card flat color="white" v-if="ticket">
        <!-- <v-toolbar flat color='white'>
            
            <v-spacer></v-spacer>

        </v-toolbar> -->
        <v-card-text class="mt-0 pt-0">
            <v-layout wrap justify-center>
                <v-flex xs8 class="text-xs-left pr-2">
                    <v-flex xs12>
                        <v-layout align-center justify-start>
                            <v-flex xs1>
                                <v-icon @click="routeToTickets()">arrow_back</v-icon>
                            </v-flex>
                            <v-flex xs10>
                                <v-layout align-center justify-start style="padding-left: 10px" class="text-xs-left">
                                    <h3 v-if="!editTitle" style="cursor: pointer">{{ticket.name}}</h3>

                                    <v-text-field v-else v-model="ticket.name"></v-text-field>

                                    <v-btn icon @click="editTitle=true" v-if="!editTitle">
                                        <v-icon>edit</v-icon>

                                    </v-btn>
                                    <v-layout v-else justify-center>
                                        <v-btn icon @click="updateTicket()">
                                            <v-icon color="green">check</v-icon>
                                        </v-btn>
                                        <v-btn icon @click="editTitle=false">
                                            <v-icon color="red">cancel</v-icon>
                                        </v-btn>

                                    </v-layout>
                                </v-layout>
                            </v-flex>

                        </v-layout>

                        <!-- <v-toolbar-title> -->

                    </v-flex>
                    <v-flex xs12>
                        <v-layout align-center justify-center>
                            <v-flex xs10>
                                <h4 v-if="!editDescription" class="darkgrey--text font-weight-light pa-2 ma-2" style="text-align: left; word-wrap: break-word">
                                    {{ ticket.description }}
                                </h4>

                                <v-textarea v-else box auto-grow v-model="ticket.description"></v-textarea>

                            </v-flex>
                            <v-flex xs2 class="text-xs-center">
                                <v-btn icon @click="editDescription=true" v-if="!editDescription">
                                    <v-icon>edit</v-icon>

                                </v-btn>
                                <v-layout v-else justify-center>
                                    <v-btn icon @click="updateTicket()">
                                        <v-icon color="green">check</v-icon>
                                    </v-btn>
                                    <v-btn icon @click="editDescription=false">
                                        <v-icon color="red">cancel</v-icon>
                                    </v-btn>

                                </v-layout>

                            </v-flex>

                        </v-layout>
                    </v-flex>

                    <v-layout wrap justify-start>
                        <v-flex xs12>
                            <v-layout align-center justify-center wrap>
                                <v-flex xs9>

                                    <at-ta :members="organisationUsers.map(x=>x.fullname)">
                                        <v-textarea class="my-0 py-0" auto-grow rows="1" outline label="Comment" row-height="16" v-model="comment.comment"></v-textarea>
                                        <!-- <wysiwyg v-model="comment.comment" /> -->
                                    </at-ta>
                                </v-flex>
                                <v-flex xs3 class="text-xs-left pl-3">
                                    <v-btn class="ma-0 pa-0" icon @click="addComment()">
                                        <v-icon>send</v-icon>
                                    </v-btn>
                                    <v-checkbox class="ma-0 pa-0" label="Internal" v-model="comment.isInternal"></v-checkbox>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12 v-for="item in history" :key="item.id" class="mt-1">
                            <v-layout v-if="item.commentLogType == false" text-xs-center wrap justify-start>
                                <v-flex xs12 class="text-xs-left">
                                    <b>{{ item.assignedByName
                            }} {{ item.assignedBySurname}}</b>
                                    assigned the ticket to
                                    <b>{{ item.assignedToName }}
                                        {{ item.assignedToSurname }}</b>
                                </v-flex>
                                <v-flex xs12 class="text-xs-left">
                                    <span style="color: grey; font-size: 10px">{{ formatDateTime(item.createdAt) }}</span>
                                </v-flex>
                            </v-layout>
                            <v-layout v-else-if="item.commentLogType == true" justify-start align-center>
                                <v-flex xs2>
                                    <b>{{ item.commentedByName
                            }} {{ item.commentedBySurname}}</b> <br>
                                    <span style="color: grey; font-size: 10px">{{ formatDateTime(item.createdAt) }}</span>
                                </v-flex>
                                <div class="talk-bubble tri-right round left-in" style="max-width: 70%">
                                    <v-flex class="text-xs-left pa-2">

                                        <span class="darkgrey--text text-xs-left" v-html="item.comment"></span>
                                    </v-flex>
                                </div>
                                <v-spacer></v-spacer>
                                <v-chip style="margin-left: 40px" small outline v-if="item.isInternal" color="blue">
                                    <v-icon small color="blue" class="mx-1">label</v-icon> Internal
                                </v-chip>
                            </v-layout>

                            <v-layout v-else-if="item.hoursLogType == true" text-xs-center wrap justify-start>
                                <v-flex xs12 class="text-xs-left">
                                    <b>{{ item.contactName
                            }} {{ item.contactSurname}}</b>
                                    worked until
                                    <b>{{ formatDateTime(item.stoppedDate) }}</b>
                                </v-flex>
                                <v-flex xs12 class="text-xs-left">
                                    <span style="color: grey; font-size: 10px">{{ formatDateTime(item.createdAt) }}</span>
                                </v-flex>
                            </v-layout>
                            <v-layout v-else-if="item.statusLog == true" text-xs-center wrap justify-start>
                                <v-flex xs12 class="text-xs-left">

                                    <b>{{ item.contact.name
                            }} {{ item.contact.surname}}</b>
                                    changed the status from <v-chip small :color="getStatusColor(item.fromStatus)" class="white--text">{{item.fromStatus}}</v-chip> to <v-chip small :color="getStatusColor(item.toStatus)" class="white--text">{{item.toStatus}}</v-chip>
                                </v-flex>
                                <v-flex xs12 class="text-xs-left">
                                    <span style="color: grey; font-size: 10px">{{ formatDateTime(item.createdAt) }}</span>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex xs12 class="mt-1" v-if="ticket.createdBy">
                            <v-flex xs12 class="text-xs-left">
                                <b>{{ticket.createdBy.name}} {{ticket.createdBy.surname}}</b>
                                created the ticket.
                            </v-flex>
                            <v-flex xs12 class="text-xs-left">
                                <span style="color: grey; font-size: 10px">{{ formatDateTime(ticket.createdAt) }}</span>
                            </v-flex>
                        </v-flex>
                    </v-layout>
                </v-flex>
                <v-flex xs4>
                    <v-list two-line>
                        <v-list-tile style="border-top: 1px solid lightgrey">
                            <v-list-tile-action>
                                <v-icon>notifications</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                                <v-layout wrap justify-start align-center :key="subscriberKey">
                                    <v-flex v-for="subscriber in ticket.ticketSubscribers" :key="subscriber.id">
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on }">
                                                <v-avatar ma-1 v-on="on" size="28px" color="primary" class="title white--text ma-1">
                                                    <span class="smallText" v-if="subscriber.contact">{{ subscriber.contact.name.charAt(0)
                              }}{{
                                subscriber.contact.surname.charAt(0)
                              }}</span>
                                                </v-avatar>
                                            </template>
                                            <span v-if="subscriber.contact">{{ subscriber.contact.name
                              }} {{
                                subscriber.contact.surname
                              }}</span>
                                        </v-tooltip>
                                    </v-flex>
                                </v-layout>
                            </v-list-tile-content>
                            <v-list-tile-action>
                                <v-tooltip bottom v-if="!ticket.ticketSubscribers.map(x=>x.contactId).includes($store.state.user.id)">
                                    <template v-slot:activator="{ on }">
                                        <v-btn v-on="on" icon @click="subscribeTicket()">
                                            <v-icon>notification_add</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Subscribe to Ticket Updates</span>
                                </v-tooltip>

                                <v-tooltip bottom v-else>
                                    <template v-slot:activator="{ on }">
                                        <v-btn v-on="on" icon @click="unsubscribeTicket()">
                                            <v-icon color="red">notifications_off</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Unsubscribe from Ticket Updates</span>
                                </v-tooltip>
                            </v-list-tile-action>
                        </v-list-tile>
                        <v-list-tile style="border-top: 1px solid lightgrey">
                            <v-list-tile-action>
                                <v-icon>event</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                                <v-list-tile-title>
                                    <span @click="dateModal=true" style="cursor: pointer">{{formatDate(ticket.dueDate)}}</span>
                                </v-list-tile-title>
                            </v-list-tile-content>
                            <v-list-tile-action style="width: 150px">
                                <VueCtkDateTimePicker format="HH:mm" formatted="HH:mm" minuteInterval="5" label="Due Time" only-time v-model="ticket.dueTime" />
                                <!-- <span v-if="ticket.dueTime">{{formatTime(ticket.dueTime)}}</span> -->
                                <!-- <v-select hide-selected :items="statuses" v-model="ticket.currentStatus" @change="updateTicket()"></v-select> -->
                            </v-list-tile-action>
                        </v-list-tile>
                        <v-list-tile style="border-top: 1px solid lightgrey">
                            <v-list-tile-action>
                                <v-icon :color="getStatusColor(ticket.currentStatus)">noise_control_off</v-icon>

                            </v-list-tile-action>
                            <v-list-tile-content>
                                <v-list-tile-title>
                                    Status
                                </v-list-tile-title>
                            </v-list-tile-content>
                            <v-list-tile-action style="width: 150px">
                                <v-select hide-selected :items="statuses" v-model="ticket.currentStatus" style="fontSize: 12px;" @change="updateTicket()"></v-select>
                            </v-list-tile-action>
                        </v-list-tile>
                        <v-list-tile style="border-top: 1px solid lightgrey">
                            <v-list-tile-action>
                                <v-icon>report</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                                <v-list-tile-title>
                                    Priority
                                </v-list-tile-title>
                            </v-list-tile-content>
                            <v-list-tile-action style="width: 150px">
                                <v-select hide-selected :disabled="ticket.isSystemGenerated" :items="importanceOptions" v-model="ticket.importance" style="fontSize: 12px;" @change="updateTicket()"></v-select>
                            </v-list-tile-action>
                        </v-list-tile>
                        <v-list-tile  style="border-top: 1px solid lightgrey">
                            <v-list-tile-action>
                                <v-icon>business</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                                <v-list-tile-title>
                                    Shared With:
                                </v-list-tile-title>
                            </v-list-tile-content>
                            <v-list-tile-action style="width: 200px">
                                <v-autocomplete :disabled="ticket.isSystemGenerated" ref="customerOrganisations" v-on:blur="$refs['customerOrganisations'].blur()" clearable @change="updateTicket()" :items="customerOrganisations" item-text="connectedOrganisation.name" item-value="connectedOrganisation.id" v-model="ticket.customerOrganisationId"></v-autocomplete>

                            </v-list-tile-action>
                        </v-list-tile>
                        <v-list-tile style="border-top: 1px solid lightgrey;" v-if="!ticket.isSystemGenerated">
                            <v-list-tile-action>
                                <v-icon>category</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content v-if="!editCategory">
                                <v-list-tile-title v-if="ticket.ticketCategory">
                                    <span v-if="ticket.ticketCategoryItem">{{ticket.ticketCategory.name}}: </span> <span v-if="ticket.ticketCategoryItem">{{ticket.ticketCategoryItem.name}}</span>
                                </v-list-tile-title>
                                <v-list-tile-sub-title>
                                    Category
                                </v-list-tile-sub-title>
                            </v-list-tile-content>
                            <v-list-tile-content v-else>
                                <v-layout>
                                    <v-autocomplete :disabled="ticket.isSystemGenerated" ref="ticketCategory" label="Category" style="fontSize: 12px; height:30px" @change="categoryKey++, ticket.ticketCategoryItemId=null" v-on:blur="$refs['ticketCategory'].blur()" :items="ticketCategory" item-text="name" item-value="id" return-object v-model="ticket.ticketCategory"></v-autocomplete>
                                    <v-autocomplete :disabled="ticket.isSystemGenerated" class="px-2" label="Subcategory" clearable style="fontSize: 12px; height:30px" ref="ticketCategoryItems" :key="categoryKey" v-on:blur="$refs['ticketCategoryItems'].blur()" :items="ticket.ticketCategory.ticketCategoryItems" item-text="name" item-value="id" v-model="ticket.ticketCategoryItemId"></v-autocomplete>
                                </v-layout>
                            </v-list-tile-content>
                            <v-list-tile-action>
                                <v-icon @click="editCategory=true" v-if="!editCategory">edit</v-icon>
                                <v-layout v-else>
                                    <v-btn icon @click="updateTicket()">
                                        <v-icon color="green">check</v-icon>
                                    </v-btn>
                                    <v-btn class="ml-2" icon @click="editCategory=false">
                                        <v-icon color="red">cancel</v-icon>
                                    </v-btn>

                                </v-layout>
                            </v-list-tile-action>
                        </v-list-tile>
                        <v-list-tile style="border-top: 1px solid lightgrey;" v-else>
                            <v-list-tile-action>
                                <v-icon>category</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                                <v-list-tile-title>
                                    {{ticket.ticketCategoryItem.ticketCategory.name}}: {{ticket.ticketCategoryItem.name}}
                                </v-list-tile-title>
                                <v-list-tile-sub-title>
                                    Category
                                </v-list-tile-sub-title>
                            </v-list-tile-content>
                        </v-list-tile>
                        <!-- <v-list-tile v-if="ticket.createdBy" style="border-top: 1px solid lightgrey">
                            <v-list-tile-action>
                                <v-icon>person</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                                <v-list-tile-title>
                                    <span>{{ticket.createdBy.name}} {{ticket.createdBy.surname}}</span>
                                </v-list-tile-title>
                                <v-list-tile-sub-title>
                                    Created: {{formatDateTime(ticket.createdAt)}}
                                </v-list-tile-sub-title>
                            </v-list-tile-content>
                        </v-list-tile> -->
                        <v-list-tile style="border-top: 1px solid lightgrey" v-if="!ticket.isSystemGenerated">
                            <v-list-tile-action>
                                <v-icon>person</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                                <v-list-tile-title v-if="ticket.assignedTo">
                                    <span>{{ticket.assignedTo.name}} {{ticket.assignedTo.surname}}</span>
                                </v-list-tile-title>
                                <v-list-tile-sub-title>
                                    <span v-if="ticket.assignedTo">Assigned</span> <span v-else>Unassigned</span>
                                </v-list-tile-sub-title>
                            </v-list-tile-content>
                            <v-list-tile-action style="width: 150px;">
                                <v-autocomplete ref="assignedUser" label="Reassign" v-on:blur="$refs['assignedUser'].blur()" style="fontSize: 12px;" :items="organisationUsers.filter(x=>x.id != ticket.assignedToId)" clearable item-text="fullname" item-value="id" v-model="ticket.assignedToId" @change="setAssign()"></v-autocomplete>
                            </v-list-tile-action>
                        </v-list-tile>
                        <v-list-tile style="border-top: 1px solid lightgrey" v-else>
                            <v-list-tile-action>
                                <v-icon>dns</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                                <v-list-tile-title>
                                    System Generated
                                </v-list-tile-title>
                            </v-list-tile-content>
                            <!-- <v-list-tile-action v-if="ticket.status != 'Complete'">
                                    <v-tooltip top>
                                            <template v-slot:activator="{ on }">
                                                <v-btn v-on="on" flat color="blue" @click="ticketExecutionModal=true">
                                                   <v-icon class="mr-1">not_started</v-icon> Execute Ticket
                                                </v-btn>
                                            </template>
                                            <span>This triggers immediate execution of the ticket, instead of waiting until the set due date</span>
                                        </v-tooltip>
                            </v-list-tile-action> -->
                        </v-list-tile>
                        <v-list-tile v-if="ticket.resolvedBy" style="border-top: 1px solid lightgrey">
                            <v-list-tile-action>
                                <v-icon>person</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                                <v-list-tile-title>
                                    <span>{{ticket.resolvedBy.name}} {{ticket.resolvedBy.surname}}</span>
                                </v-list-tile-title>
                                <v-list-tile-sub-title>
                                    Resolved
                                </v-list-tile-sub-title>
                            </v-list-tile-content>
                        </v-list-tile>

                        <v-list-tile v-if="editLocation">
                            <v-list-tile-content style="width:90%">
                                <v-autocomplete ref="location" style="font-size: 12px;width:100%" clearable v-on:blur="$refs['location'].blur()" dense v-model="ticket.location" return-object :items="locations" item-text="locationDescription" item-value="id" :loading="isLoading" placeholder="Search for Location" :search-input.sync="searchLocation" color="black" hide-no-data hide-selected></v-autocomplete>
                            </v-list-tile-content>
                            <v-list-tile-action>
                                <v-btn icon @click="updateTicketItem({id: ticket.id, switchingCentreId: null, locationNetworkId: null, locationNodeId: null, locationId: ticket.location?ticket.location.id:null}), editLocation= false">
                                    <v-icon color="primary">check</v-icon>
                                </v-btn>
                            </v-list-tile-action>
                        </v-list-tile>

                        <v-list-tile v-if="editNetwork">
                            <v-list-tile-content style="width:90%">
                                <v-autocomplete ref="locationNetwork" style="font-size: 12px;width:100%" clearable v-on:blur="$refs['locationNetwork'].blur()" dense v-model="ticket.locationNetwork" return-object :items="locationNetworks" item-text="name" item-value="id" :loading="isLoading" placeholder="Search Networks" :search-input.sync="searchNetwork" color="black" hide-no-data hide-selected></v-autocomplete>
                            </v-list-tile-content>
                            <v-list-tile-action>
                                <v-btn icon @click="updateTicketItem({id: ticket.id, locationId: null, switchingCentreId: null, locationNodeId: null, locationNetworkId: ticket.locationNetwork?ticket.locationNetwork.id:null}), editNetwork= false">
                                    <v-icon color="primary">check</v-icon>
                                </v-btn>
                            </v-list-tile-action>
                        </v-list-tile>

                        <v-list-tile v-if="editNode">
                            <v-list-tile-content style="width:90%">
                                <v-autocomplete ref="locationNode" style="font-size: 12px;width:100%" clearable v-on:blur="$refs['locationNode'].blur()" dense v-model="ticket.locationNode" return-object :items="locationNodes" item-text="name" item-value="id" :loading="isLoading" placeholder="Search for Node" :search-input.sync="searchNode" color="black" hide-no-data hide-selected></v-autocomplete>
                            </v-list-tile-content>
                            <v-list-tile-action>
                                <v-btn icon @click="updateTicketItem({id: ticket.id, locationId: null, locationNetworkId: null, switchingCentreId: null, locationNodeId: ticket.locationNode?ticket.locationNode.id:null}), editNode= false">
                                    <v-icon color="primary">check</v-icon>
                                </v-btn>
                            </v-list-tile-action>
                        </v-list-tile>

                        <v-list-tile v-if="editSwitchingCentre">
                            <v-list-tile-content style="width:90%">
                                <v-autocomplete ref="switchingCentre" style="font-size: 12px;width:100%" clearable v-on:blur="$refs['switchingCentre'].blur()" dense v-model="ticket.switchingCentre" return-object :items="switchingCentres" item-text="name" item-value="id" :loading="isLoading" placeholder="Search for Centre" :search-input.sync="searchSwitchingCentre" color="black" hide-no-data hide-selected></v-autocomplete>
                            </v-list-tile-content>
                            <v-list-tile-action>
                                <v-btn icon @click="updateTicketItem({id: ticket.id, locationId: null, locationNetworkId: null, locationNodeId: null, switchingCentreId: ticket.switchingCentre?ticket.switchingCentre.id:null}), editSwitchingCentre= false">
                                    <v-icon color="primary">check</v-icon>
                                </v-btn>
                            </v-list-tile-action>
                        </v-list-tile>

                        <v-list-tile v-else-if="!editLocation&&!editNetwork&&!editNode&&!editSwitchingCentre" style="border-top: 1px solid lightgrey">
                            <v-list-tile-action>
                                <v-menu offset-y style="width: 80%">
                                    <template v-slot:activator="{ on }">
                                        <v-btn flat color="black" style="border-radius: 5px; width: 80%" v-on="on">
                                            <v-icon v-if="ticket.locationType == 'location'">location_on</v-icon>
                                            <v-icon v-else-if="ticket.locationType == 'network'">share</v-icon>
                                            <v-icon v-else-if="ticket.locationType == 'node'">device_hub</v-icon>
                                            <v-icon v-else-if="ticket.locationType == 'switchingCentre'">business</v-icon>
                                            <v-icon class="ml-2" small>arrow_drop_down</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-list>
                                        <v-list-tile v-for="(type, index) in locationTypes" :key="index" @click="ticket.locationType = type.value">
                                            <v-list-tile-action>
                                                <v-icon>{{type.icon}}</v-icon>
                                            </v-list-tile-action>
                                            <v-list-tile-title>{{ type.name }}</v-list-tile-title>
                                        </v-list-tile>
                                    </v-list>
                                </v-menu>
                            </v-list-tile-action>

                            <v-list-tile-content :key="locationKey" v-if="ticket.locationType == 'location'">
                                <v-list-tile-title style="font-size:12px">
                                    <span v-if="ticket.location">{{ticket.location.locationDescription}}</span>
                                    <span v-else>No attached location</span>
                                </v-list-tile-title>
                                <v-list-tile-sub-title style="font-size:12px" v-if="ticket.location&&ticket.locationNetwork">
                                    {{ticket.location.locationNetwork.name}}
                                </v-list-tile-sub-title>
                            </v-list-tile-content>
                            <v-list-tile-content :key="locationKey" v-if="ticket.locationType == 'network'">
                                <v-list-tile-title style="font-size:12px">
                                    <span v-if="ticket.locationNetwork">{{ticket.locationNetwork.name}}</span>
                                    <span v-else>No attached Network</span>
                                </v-list-tile-title>
                                <v-list-tile-sub-title style="font-size:12px" v-if="ticket.locationNetwork&&ticket.locationNetwork.locationNode">
                                    {{ticket.locationNetwork.locationNode.name}}
                                </v-list-tile-sub-title>
                            </v-list-tile-content>
                            <v-list-tile-content :key="locationKey" v-if="ticket.locationType == 'node'">
                                <v-list-tile-title style="font-size:12px">
                                    <span v-if="ticket.locationNode">{{ticket.locationNode.name}}</span>
                                    <span v-else>No attached Node</span>
                                </v-list-tile-title>
                                <v-list-tile-sub-title style="font-size:12px" v-if="ticket.locationNode && ticket.locationNode.switchingCentre">
                                    {{ticket.locationNode.switchingCentre.name}}
                                </v-list-tile-sub-title>
                            </v-list-tile-content>
                            <v-list-tile-content :key="locationKey" v-if="ticket.locationType == 'switchingCentre'">
                                <v-list-tile-title style="font-size:12px">
                                    <span v-if="ticket.switchingCentre">{{ticket.switchingCentre.name}}</span>
                                    <span v-else>No attached Switching Centre</span>
                                </v-list-tile-title>
                            </v-list-tile-content>
                            <v-list-tile-action :key="locationKey">
                                <v-layout justify-center>
                                    <v-flex>
                                        <v-btn v-if="ticket.locationType == 'location'" small icon @click="editLocation = true">
                                            <v-icon small>edit</v-icon>
                                        </v-btn>

                                        <v-btn v-if="ticket.locationType == 'network'" small icon @click="editNetwork = true">
                                            <v-icon small>edit</v-icon>
                                        </v-btn>
                                        <v-btn v-if="ticket.locationType == 'node'" small icon @click="editNode = true">
                                            <v-icon small>edit</v-icon>
                                        </v-btn>
                                        <v-btn v-if="ticket.locationType == 'switchingCentre'" small icon @click="editSwitchingCentre = true">
                                            <v-icon small>edit</v-icon>
                                        </v-btn>
                                    </v-flex>
                                    <v-flex>
                                        <v-btn :disabled="!ticket.locationId && !ticket.locationNetworkId && !ticket.locationNodeId && !ticket.switchingCentreId" icon small @click="routeToLocation()">
                                            <v-icon small>launch</v-icon>
                                        </v-btn>
                                    </v-flex>

                                </v-layout>

                            </v-list-tile-action>

                            <!-- <v-list-tile-content v-if="ticket.location">
                                <v-list-tile-title>
                                    <span>{{ticket.location.locationDescription}}</span>
                                </v-list-tile-title>
                                <v-list-tile-sub-title v-if="ticket.location&&ticket.location.locationNetwork">
                                    {{ticket.location.locationNetwork.name}}
                                </v-list-tile-sub-title>
                            </v-list-tile-content>
                            <v-list-tile-content v-else-if="ticket.locationNetwork">
                                <v-list-tile-title>
                                    <span>{{ticket.locationNetwork.name}}</span>
                                </v-list-tile-title>
                                <v-list-tile-sub-title v-if="ticket.locationNetwork&&ticket.locationNetwork.locationNode">
                                    {{ticket.locationNetwork.locationNode.name}}
                                </v-list-tile-sub-title>
                            </v-list-tile-content>
                            <v-list-tile-content v-else-if="ticket.locationNode">
                                <v-list-tile-title>
                                    <span>{{ticket.locationNode.name}}</span>
                                </v-list-tile-title>
                            </v-list-tile-content> -->
                            <!-- <v-list-tile-action v-if="ticket.location">
                                <v-icon @click="routeToLocation()">launch</v-icon>
                            </v-list-tile-action> -->
                        </v-list-tile>

                        <v-list-tile style="border-top: 1px solid lightgrey">
                            <v-list-tile-action>
                                <v-icon>description</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                                <v-list-tile-title style=" align-text: center;cursor: pointer" v-if="documents.length>0" @click="documentsModal=true">
                                    <v-chip style="height: 20px">{{documents.length}}</v-chip> Document(s)
                                </v-list-tile-title>
                                <v-list-tile-title v-else>
                                    No documents
                                </v-list-tile-title>
                            </v-list-tile-content>
                            <v-list-tile-action>

                                <div :class="['dropZone', dragging ? 'dropZone-over' : '']" @dragenter="dragging = true" @dragleave="dragging = false">
                                    <div class="dropZone-info" @drag="onChange">
                                        <!-- <v-btn icon><v-icon>add</v-icon></v-btn> -->
                                        <span class="dropZone-title" style="font-size: 12px; cursor: pointer">Drop file or click to upload</span>
                                    </div>
                                    <input type="file" @change="onChange">
                                </div>

                            </v-list-tile-action>
                        </v-list-tile>

                        <v-list-tile v-if="ticket.serviceAccount" style="border-top: 1px solid lightgrey">
                            <v-list-tile-action>
                                <v-icon>miscellaneous_services</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                                <v-list-tile-title>
                                    {{ticket.serviceAccount.circuitNumber}}
                                </v-list-tile-title>
                                <v-list-tile-sub-title>
                                    <v-chip style="height: 18px" outline v-if="ticket.serviceAccount.fnoActivationDate!==null&&new Date(ticket.serviceAccount.fnoActivationDate)<new Date()&&ticket.serviceAccount.isSuspended&&ticket.serviceAccount.isActive" class="white--text" color="orange">Suspended</v-chip>
                                    <v-chip style="height: 18px" outline v-else-if="ticket.serviceAccount.fnoActivationDate!==null&&new Date(ticket.serviceAccount.fnoActivationDate)<new Date()&&(new Date(ticket.serviceAccount.fnoDeactivationDate)>new Date()||ticket.serviceAccount.fnoDeactivationDate==null)" class="white--text" color="light-green">Active</v-chip>
                                    <v-chip style="height: 18px" outline v-else-if="ticket.serviceAccount.fnoActivationDate!==null&&ticket.serviceAccount.fnoDeactivationDate!=null&&(new Date(ticket.serviceAccount.fnoDeactivationDate)<new Date())" class="white--text" color="red">Inactive</v-chip>
                                    <v-chip style="height: 18px" outline v-else-if="ticket.serviceAccount.fnoActivationDate==null||new Date(ticket.serviceAccount.fnoActivationDate)>new Date()" class="white--text" color="blue">Pending</v-chip>
                                </v-list-tile-sub-title>
                            </v-list-tile-content>
                            <v-list-tile-action>
                                <v-icon @click="routeToServiceAccount()">launch</v-icon>
                            </v-list-tile-action>
                        </v-list-tile>

                        <v-list-tile v-if="ticket.application" style="border-top: 1px solid lightgrey;">
                            <v-list-tile-action>
                                <v-icon>receipt</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                                <v-list-tile-title>
                                    Order: #{{ticket.application.id}}
                                </v-list-tile-title>
                                <v-list-tile-sub-title>
                                    <v-chip color="green" class="white--text" style="height: 18px" small outline v-if="ticket.application.isResolved && ticket.application.isApproved">Approved</v-chip>
                                    <v-chip color="red" outline class="white--text" style="height: 18px" v-else-if="ticket.application.isResolved && ticket.application.isDenied">Denied</v-chip>
                                    <v-chip color="light-blue" outline class="white--text" style="height: 18px" v-else>Pending</v-chip>
                                </v-list-tile-sub-title>
                            </v-list-tile-content>
                            <v-list-tile-action>
                                <v-icon @click="routeToApplication()">launch</v-icon>
                            </v-list-tile-action>
                        </v-list-tile>

                        <v-list-tile v-if="ticket.customerOrganisation" style="border-top: 1px solid lightgrey; border-bottom: 1px solid lightgrey">
                            <v-list-tile-avatar>
                                <v-img contain :src="ticket.customerOrganisation.logo"></v-img>
                            </v-list-tile-avatar>
                            <v-list-tile-content>
                                <v-list-tile-title>
                                    {{ ticket.customerOrganisation.name}}
                                </v-list-tile-title>
                                <v-list-tile-sub-title>
                                </v-list-tile-sub-title>
                            </v-list-tile-content>
                            <v-list-tile-action>
                                <v-icon @click="routeToOrganisation()">launch</v-icon>
                            </v-list-tile-action>
                        </v-list-tile>
                        <v-list-tile v-if="ticket.serviceLevelAgreement" style="border-top: 1px solid lightgrey; border-bottom: 1px solid lightgrey">
                            <v-list-tile-action>
                                <v-icon>article</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                                <v-list-tile-title>
                                    {{ ticket.serviceLevelAgreement.name}}
                                </v-list-tile-title>
                                <v-list-tile-sub-title>
                                    Service Level Agreement
                                </v-list-tile-sub-title>
                            </v-list-tile-content>
                            <v-list-tile-action>
                                <!-- <v-icon @click="routeToApplication()">launch
                                    </v-icon> -->
                            </v-list-tile-action>
                        </v-list-tile>
                    </v-list>

                </v-flex>

            </v-layout>
        </v-card-text>
    </v-card>

    <v-dialog v-model="documentsModal" persistent width="750px">
        <v-card>
            <v-toolbar flat color="white">
                <v-toolbar-title>
                    Documents
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn flat @click="documentsModal=false">X</v-btn>
            </v-toolbar>
            <v-card-text>
                <v-layout justify-center align-center wrap>
                    <v-flex xs12 v-for="document in documents" :key="document.id">
                        <v-card flat color="white" style="border-top: 1px solid lightgrey">
                            <v-layout justify-left align-center wrap>
                                <v-flex xs3>
                                    <h4 class="grey--text font-weight-light">{{formatDate(new Date(document.createdAt))}}</h4>
                                </v-flex>
                                <v-flex xs7>
                                    <h4 class="grey--text">{{document.name}}</h4>
                                </v-flex>
                                <v-flex xs2>
                                    <v-layout justify-center>
                                        <!-- <v-icon @click="viewFile(document)">open_in_new</v-icon> -->
                                        <v-icon @click="downloadFile(document)">download</v-icon>
                                        <v-icon color="red" @click="deleteFile(document)">delete</v-icon>
                                    </v-layout>
                                </v-flex>
                            </v-layout>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-card-text>
        </v-card>
    </v-dialog>

    <v-dialog ref="dialog" v-model="dateModal" lazy full-width width="750px">
        <v-date-picker style="height: 350px" landscape full-width scrollable v-model="pickerDate">
            <v-spacer></v-spacer>
            <v-btn flat color="primary" @click="dateModal=false">OK</v-btn>
        </v-date-picker>

    </v-dialog>

    <v-dialog v-model="ticketExecutionModal" width="500px">
        <v-card>
            <v-toolbar flat color="white">
                <v-toolbar-title>
                    Execute Ticket
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn flat @click="ticketExecutionModal= false">X</v-btn>
            </v-toolbar>
            <v-card-text v-if="!executingTicket">
                <v-layout justify-center wrap>
                    <v-flex xs10>
                        <span class="grey--text">Are you sure you want to execute this ticket now?</span>
                    </v-flex>
                    <v-flex xs4>
                        <v-btn flat color="red" @click="ticketExecutionModal=false">No</v-btn>
                    </v-flex>
                    <v-flex xs4>
                        <v-btn flat color="green" @click="triggerTicketExecution()">Yes</v-btn>
                    </v-flex>
                </v-layout>
            </v-card-text>
            <v-card-text v-else>
                <v-layout wrap justify-center v-if="loadingExecution">
                    <v-flex xs10>
                         <v-progress-circular indeterminate color="blue" size="20"></v-progress-circular>
                    </v-flex>
                    <v-flex xs10 class="text-xs-center mt-2">
                        <span class="grey--text">Loading...</span>
                    </v-flex>
                </v-layout>
                <v-layout wrap justify-center v-else>
                    <v-flex xs10>
                         <v-progress-circular indeterminate color="blue" size="20"></v-progress-circular>
                    </v-flex>
                    <v-flex xs10 class="text-xs-center mt-2">
                        <span class="grey--text">Loading...</span>
                    </v-flex>
                </v-layout>
            </v-card-text>
        </v-card>
    </v-dialog>

</div>
</template>

<script>
import Api from "@/services/Api.js";
import dateformat from 'dateformat'
import At from "vue-at";
import AtTa from "vue-at/dist/vue-at-textarea"; // for textarea
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
export default {
    components: {
        At,
        AtTa,
        VueCtkDateTimePicker
    },
    data() {
        return {
            assignments: [],
            comment: {
                isInternal: true
            },
            comments: [],
            customerOrganisations: [],
            dateModal: false,
            documents: [],
            documentsModal: false,
            dragging: false,
            editLocation: false,
            editNetwork: false,
            editNode: false,
            editSwitchingCentre: false,
            editTitle: false,
            editDescription: false,
            editCategory: false,
            file: '',
            hours: [],
            locationTypes: [{
                    name: 'Location',
                    value: 'location',
                    icon: 'location_on'
                },
                {
                    name: 'Network',
                    value: 'network',
                    icon: 'share'
                },
                {
                    name: 'Node',
                    value: 'node',
                    icon: 'device_hub'
                },
                {
                    name: 'Switching Centre',
                    value: 'switchingCentre',
                    icon: 'business'
                },

            ],
            pickerDate: new Date().toISOString().substr(0, 10),
            statuses: ["Incomplete", "Pending", "In Progress", "Complete", "Canceled"],
            importanceOptions: ["Normal", "Not Critical", "Average", "Urgent"],
            organisationUsers: [],
            isLoading: false,
            searchLocation: null,
            searchNetwork: null,
            searchNode: null,
            searchSwitchingCentre: null,
            locations: [],
            locationNetworks: [],
            locationsNodes: [],
            switchingCentres: [],
            locationKey: 0,
            subscriberKey: 0,
            statusLog: [],
            ticket: {},
            ticketCategory: [],
            categoryKey: 0,
            ticketExecutionModal: false,
            executingTicket: false,
            loadingExecution: false
        }
    },
    async created() {
        this.ticket = await this.getTicket()
        if (this.ticket.dueDate) {
            this.pickerDate = new Date(this.ticket.dueDate).toISOString().substr(0, 10)
        } else {
            this.pickerDate = new Date().toISOString().substr(0, 10)

        }
       
        this.comments = await this.fetchTicketComments(this.$route.params.ticketId)
        this.hours = await this.fetchTicketJobHours(this.$route.params.ticketId)
        this.assignments = await this.fetchTicketAssignments(this.$route.params.ticketId)
        this.statusLog = await this.fetchStatusLog(this.$route.params.ticketId)
        this.documents = await this.fetchTicketDocuments(this.$route.params.ticketId)
        this.ticketCategory = await this.fetchTicketCategories()
        if (!this.ticket.ticketCategory)
            this.ticket.ticketCategory = this.ticketCategory.find(x => x.id == this.ticket.ticketCategoryId)
        
         if (!this.ticket.name) {
            let name = this.ticket.ticketCategory.name ? this.ticket.ticketCategory.name: ''
            if(this.ticket.ticketCategoryItem){
                name += ': ' + this.ticket.ticketCategoryItem.ticketCategory.name
            }
            this.ticket.name = name
        }
        console.log(this.ticket)
        this.fetchConnectedOrganisations()
        this.fetchOrgContacts()
    },
    watch: {
        pickerDate(value) {
            if (value) {
                this.ticket.dueDate = new Date(value)
            }
        },
        "ticket.dueDate": {
            immediate: true,
            async handler(value) {
                if (value) {
                    this.updateTicket()
                }
            }
        },
        "ticket.dueTime": {
            immediate: true,
            async handler(value) {
                // if(value){
                this.updateTicket()
                // }
            }
        },
        searchLocation(val) {
            // Items have already been loaded
            // if (this.locations.length > 0) return

            // Items have already been requested
            if (this.isLoading) return

            this.isLoading = true

            // Lazily load input items
            Api().get('/Locations/elasticSearch', {
                params: {
                    search: val
                }
            }).then(res => {
                this.locations = res.data
            }).finally(() => (this.isLoading = false))
        },

        searchNetwork(val) {
            if (this.isLoading) return
            this.isLoading = true
            Api().get('/locationNetworks/elasticSearch', {
                params: {
                    search: val
                }
            }).then(res => {
                this.locationNetworks = res.data
            }).finally(() => (this.isLoading = false))
        },
        searchNode(val) {
            if (this.isLoading) return

            this.isLoading = true
            Api().get('/locationNodes/search', {
                params: {
                    search: val
                }
            }).then(res => {
                this.locationNodes = res.data
            }).finally(() => (this.isLoading = false))
        },
        searchSwitchingCentre(val) {
            if (this.isLoading) return

            this.isLoading = true
            Api().get('/switchingCentres/search', {
                params: {
                    search: val
                }
            }).then(res => {
                this.switchingCentres = res.data
            }).finally(() => (this.isLoading = false))
        }
    },
    computed: {

        extension() {
            return (this.file) ? this.file.name.split('.').pop() : '';
        },
        history() {
            let result = [...this.comments, ...this.hours, ...this.assignments, ...this.statusLog]
            result = result.sort(
                (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
            );
            console.log(result)
            return result
        },
        ticketCategoryItems() {
            return this.ticket.ticketCategory.ticketCategoryItems
        }
    },
    methods: {

        async fetchTicketCategories() {
            let result = []
            await Api()
                .get('/ticketCategory')
                .then(response => {
                    result = response.data
                })
            return result
        },
        async addComment() {
            //   if (this.internal == true) {
            //     this.mentioned = this.members.filter((x) => comment.includes(x));
            //     await this.mentioned.map((y) => {
            //       this.membersEmail.map((x) => {
            //         if (x.fullName === y) {
            //           this.emailAddressArray.push(x.email);
            //         }
            //       });
            //     });
            //   } else {
            //     if (this.ticketItem.createdBy.permissions == "FNO Operator") {
            //       this.emailAddressArray.push(this.ticketItem.createdBy.emailAddress);
            //     } else {
            //       this.customerEmailAddressArray.push(
            //         this.ticketItem.createdBy.emailAddress
            //       );
            //     }
            //   }
            Api()
                .post("/ticketComment", {
                    isInternal: this.comment.isInternal,
                    ticketId: this.ticket.id,
                    type: "comment",
                    commentedById: this.$store.state.user.id,
                    comment: this.comment.comment,
                })
                .then((response) => {

                    this.comments.push({
                        isInternal: this.comment.isInternal,
                        commentedById: this.$store.state.user.id,
                        commentedByName: this.$store.state.user.name,
                        commentedBySurname: this.$store.state.user.surname,
                        comment: response.data.comment,
                        type: response.data.type,
                        createdAt: response.data.createdAt,
                        id: response.data.id,
                        commentLogType: true,
                    });
                    this.comment = {
                        isInternal: true
                    };
                });
        },
        createTicket() {
            Api().post('/ticket', this.ticket).then(res => {

            })
        },
        formatDateTime(date) {
            if (date !== null) {
                return dateformat(date, "yyyy-mm-dd HH:MM");
            } else {
                null;
            }
        },
        formatDate(date) {
            if (date !== null) {
                return dateformat(date, "yyyy-mm-dd");
            } else {
                null;
            }
        },
        fetchConnectedOrganisations() {
            Api().get('/organisationConnection').then(res => {
                this.customerOrganisations = res.data
            })
        },
        updateTicket() {
            Api().put('/ticket/' + this.ticket.id, this.ticket).then(res => {
                this.editDescription = false
                this.editTitle = false
                this.editCategory = false
                this.refreshStatusLog()
            })
        },
        updateTicketItem(item) {
            Api().put('/ticket/' + item.id, item).then(res => {
                this.editDescription = false
                this.editTitle = false
                this.editCategory = false
                this.refreshStatusLog()
            })
        },
        async getTicket() {
            let result = {}
            await Api().get('/ticket/' + this.$route.params.ticketId).then(res => {
                result = res.data
            })
            return result
        },
        fetchOrgContacts() {
            this.filteredUsers = [];
            Api()
                .get("/organisationContact")
                .then(async (response) => {
                    //   this.filteredUsers = response.data.filter(function (el) {
                    //     return el.userType !== "endClient";
                    //   });
                    let contactArray = await response.data.map((x) => x.contact);
                    this.members = await contactArray.map(
                        (x) => x.name + " " + x.surname
                    );
                    this.organisationUsers = contactArray.map(x => ({
                        id: x.id,
                        fullname: x.name + ' ' + x.surname,
                        name: x.name,
                        surname: x.surname,
                        email: x.email,
                        mobileNumber: x.mobileNumber
                    }))
                    //   await contactArray.map((x) => {
                    //     this.membersEmail.push({
                    //       fullName: x.name + " " + x.surname,
                    //       email: x.emailAddress,
                    //     });
                    //   });
                    //   this.filteredUsers = contactArray;
                });
        },
        async fetchTicketComments(id) {
            let result = []
            await Api()
                .get("/allTicketComment/byTicket/" + id)
                .then(async (response) => {
                    result = response.data.map(x => ({
                        commentedById: x.commentedById,
                        commentedByName: x.commentedBy.name,
                        commentedBySurname: x.commentedBy.surname,
                        comment: x.comment,
                        type: x.type,
                        createdAt: x.createdAt,
                        isInternal: x.isInternal,
                        id: x.id,
                        commentLogType: true
                    }))
                })
            return result
        },
        async fetchStatusLog(id) {
            let result = []
            await Api()
                .get("/ticketStatus/" + id)
                .then(async (response) => {
                    response.data.forEach(x => {
                        x.statusLog = true
                    })
                    console.log(result)
                    result = response.data
                })
            return result
        },
        async refreshStatusLog() {
            this.statusLog = await this.fetchStatusLog(this.$route.params.ticketId)
        },
        async fetchTicketAssignments(id) {
            let result = []
            await Api()
                .get("/ticketAssignLog/byTicket/" + id)
                .then(async (response) => {
                    result = response.data.map((x) => ({
                        assignedById: x.assignedById,
                        assignedByName: x.assignedBy.name,
                        assignedBySurname: x.assignedBy.surname,
                        assignedToId: x.assignedToId,
                        assignedToName: x.assignedTo.name,
                        assignedToSurname: x.assignedTo.surname,
                        createdAt: x.createdAt,
                        id: x.id,
                        commentLogType: false,
                    }))
                });
            return result
        },
        async fetchTicketJobHours(id) {
            let result = []
            await Api()
                .get("/ticketJobHours/byTicket/" + id)
                .then(async (response) => {
                    result = response.data.map(x => ({
                        contactId: x.contactId,
                        contactName: x.contact.name,
                        contactSurname: x.contact.surname,
                        startDate: x.startDate ? x.startDate : x.createdAt,
                        stoppedDate: x.stoppedDate,
                        createdAt: x.startDate ? x.startDate : x.createdAt,
                        id: x.id,
                        hoursLogType: true,
                    }))
                });
            return result
        },
        formatTime(time) {
            let split = time.split(':')
            return split[0] + ':' + split[1]
        },
        async fetchTicketDocuments(id) {
            let result = []
            await Api()
                .get("/upload/byTicket/" + id)
                .then(async (response) => {
                    result = response.data
                });
            return result
        },
        getStatusColor(status) {
            switch (status) {
                case 'Complete':
                    return 'light-green'
                case 'Incomplete':
                    return 'red'
                case 'Pending':
                    return 'orange'
                case 'In Progress':
                    return 'blue'
                case 'Canceled':
                    return 'red'
            }
        },
        onChange(e) {
            var files = e.target.files || e.dataTransfer.files;
            if (!files.length) {
                this.dragging = false;
                return;
            }
            this.createFile(files[0]);
        },
        async createFile(file) {
            // if (!file.type.match('text.*')) {
            //     alert('please select txt file');
            //     this.dragging = false;
            //     return;
            // }

            if (file.size > 5000000) {
                alert('please check file size no over 5 MB.')
                this.dragging = false;
                return;
            }

            this.file = file;
            var reader = new FileReader();
            await reader.readAsBinaryString(this.file);
            reader.onload = () => {
                file = btoa(reader.result)
                this.file.base64 = file;
                console.log(this.file)
                this.uploadDocument(this.file)
            }

            this.dragging = false;
        },
        removeFile() {
            this.file = '';
        },
        triggerTicketExecution(){
            this.executingTicket = true
            this.loadingExecution = true
        },
        viewFile(item) {
            const linkSource = `data:${item.type};base64,${item.base64}`;
            let pdfWindow = window.open("")
            pdfWindow.document.write(
                `<iframe width='100%' height='100%' src='${linkSource}'></iframe>`
            )
        },
        downloadFile(item) {
            const linkSource = `data:${item.type};base64,${item.base64}`;
            const downloadLink = document.createElement("a");
            const fileName = item.name;
            downloadLink.href = linkSource;
            downloadLink.download = fileName;
            downloadLink.click();
        },
        deleteFile(item) {
            Api().put('/upload/' + item.id, {
                isActive: false,
                isDeleted: true
            }).then(res => {
                this.documents.splice(this.documents.indexOf(item), 1)
            })
        },
        routeToTickets() {
            this.$router.push({
                path: "/tickets"
            });
        },
        routeToApplication() {
            var getUrl = window.location;
            var baseUrl = getUrl.protocol + "//" + getUrl.host + "/applications/" + this.ticket.applicationId
            window.open(baseUrl, "_blank")
        },
        routeToOrganisation() {
            // this.$router.push({
            //     path: "/ispList/" + this.ticket.customerOrganisationId
            // });
            var getUrl = window.location;
            var baseUrl = getUrl.protocol + "//" + getUrl.host + "/ispList/" + this.ticket.customerOrganisationId
            window.open(baseUrl, "_blank")
        },
        routeToServiceAccount() {
            // this.$router.push({
            //     path: "/serviceAccounts/" + this.ticket.serviceAccountId
            // });
            var getUrl = window.location;
            var baseUrl = getUrl.protocol + "//" + getUrl.host + "/serviceAccounts/" + this.ticket.serviceAccountId
            window.open(baseUrl, "_blank")
        },
        routeToLocation() {
            // this.$router.push({
            //     path: "/serviceAccounts/" + this.ticket.serviceAccountId
            // });
            var getUrl = window.location;
            var baseUrl = getUrl.protocol + "//" + getUrl.host + "/locationNetworks/" + this.ticket.location.locationNetworkId + "/" + this.ticket.locationId
            window.open(baseUrl, "_blank")
        },
        setUntilDate() {
            Api()
                .get("/ticketAssignLog/latest/" + this.ticket.id)
                .then((response) => {
                    Api().put("/ticketAssignLog/" + response.data[0].id, {
                        assignedUntil: new Date(),
                    });
                });
        },
        setAssign() {
            if (this.ticket.assignedToId) {
                this.setUntilDate();
                Api()
                    .get("/contact/basic/" + this.ticket.assignedToId)
                    .then(async (response) => {
                        this.ticket.assignedTo = response.data;
                        let assignedTo = response.data;
                        Api()
                            .post("/ticketAssignLog", {
                                assignedToId: this.ticket.assignedToId,
                                assignedById: this.$store.state.user.id,
                                ticketId: this.ticket.id,
                            })
                            .then(async (response) => {
                                Api().put("/ticket/" + this.ticket.id, {
                                    assignedToId: this.ticket.assignedToId,
                                });
                                this.ticket = await this.getTicket()
                                // this.assignments = await this.fetchTicketAssignments(this.$route.params.ticketId)
                                this.assignments.push({
                                    assignedById: response.data.assignedById,
                                    assignedByName: this.$store.state.user.name,
                                    assignedBySurname: this.$store.state.user.surname,
                                    assignedToId: response.data.assignedToId,
                                    assignedToName: assignedTo.name,
                                    assignedToSurname: assignedTo.surname,
                                    createdAt: response.data.createdAt,
                                    id: response.data.id,
                                    commentLogType: false,
                                })
                            });
                    });
            }

        },
        subscribeTicket() {
            Api().post('/ticketSubscriber', {
                ticketId: this.ticket.id,
                contactId: this.$store.state.user.id
            }).then(res => {
                let obj = res.data
                obj.contact = {
                    id: this.$store.state.user.id,
                    name: this.$store.state.user.name,
                    surname: this.$store.state.user.surname
                }
                this.ticket.ticketSubscribers.push(obj)
                console.log(this.ticket.ticketSubscribers)
                this.subscriberKey++
            })
        },
        uploadDocument(file) {
            this.file = {
                ticketId: this.ticket.id,
                name: file.name,
                base64: file.base64,
                type: file.type,
                isActive: true,
                isDeleted: false,
            }
            Api()
                .post('/upload', this.file).then(async response => {
                    this.file.id = response.data.id
                    this.file.createdAt = response.data.createdAt
                    this.documents.push(this.file)

                    // this.documents = await this.fetchTicketDocuments(this.$route.params.ticketId)
                })
        },
        unsubscribeTicket() {
            let find = this.ticket.ticketSubscribers.find(x => x.contactId == this.$store.state.user.id)
            Api().put('/ticketSubscriber/' + find.id, {
                isActive: false,
                isDeleted: true
            }).then(res => {
                this.ticket.ticketSubscribers.splice(this.ticket.ticketSubscribers.indexOf(find), 1)
            })
        },
    }
}
</script>

<style scoped>
.talk-bubble {
    left: 30px;
    margin: 2px;
    position: relative;
    background-color: rgb(240, 240, 240);
}

.round {
    border-radius: 15px;
    -webkit-border-radius: 15px;
    -moz-border-radius: 15px;
}

.talktext {
    padding: 0.5em;
    overflow-wrap: break-word;
    word-break: break-all;
    line-height: 1.5em;
    white-space: pre-wrap;
}

.tri-right.left-in:after {
    content: " ";
    position: absolute;
    width: 0;
    height: 0;
    left: -15px;
    top: 0;
    border: 15px solid;
    border-color: rgb(240, 240, 240) transparent transparent;
}

.dropZone {
    width: 180px;
    height: 90%;
    position: relative;
    border: 2px dashed #eee;
}

.dropZone:hover {
    border: 2px solid #2e94c4;
}

.dropZone:hover .dropZone-title {
    color: #1975A0;
}

.dropZone-info {
    color: #A8A8A8;
    position: absolute;
    top: 50%;
    width: 100%;
    transform: translate(0, -50%);
    text-align: center;
}

.dropZone-title {
    color: #787878;
}

.dropZone input {
    position: absolute;
    cursor: pointer;
    top: 0px;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
}

.dropZone-upload-limit-info {
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
}

.dropZone-over {
    background: #5C5C5C;
    opacity: 0.8;
}

.dropZone-uploaded {
    width: 80%;
    height: 200px;
    position: relative;
    border: 2px dashed #eee;
}

.dropZone-uploaded-info {
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #A8A8A8;
    position: absolute;
    top: 50%;
    width: 100%;
    transform: translate(0, -50%);
    text-align: center;
}

.removeFile {
    width: 200px;
}

.list--dense.fix .list__tile__title {
    height: 20px;
}
</style>
